<template>
  <div class="rent-hire-bd">
    <div class="wrap">
      <div class="per-wrap">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item v-if="funcView.func_related">
              <el-button type="primary" icon="el-icon-plus" @click="lessee()">{{ funcView.func_related }}</el-button>
            </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
            </el-form-item>
            <!-- 搜索项 -->
            <el-form-item style="float: right">
              <el-input :placeholder="$t('crm_rent_hire.zlfmc')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                <template slot="append">
                  <div @click="onPageChange({ page: 1 })">
                    <i class="icon icon-search"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            v-if="funcView.func_check_bind_rent_list"
            ref="tb1"
            v-loading="isLoading"
            border
            row-key="menuId"
            :size="allTableSize"
            :column="tableColumn"
            :data="rentList"
            :default-expand-all="true"
            height="100%"
            @selection-change="selectionChange"
            @sort-change="sortChange"
            @filter-change="filterChange"
            :slots="['relationType','action']"
          >
            <template slot="relationType" slot-scope="scope">
             <el-select size="mini" v-model="scope.row.relationType" :placeholder="$t('Common.com_please_select')"  @change="changeRelation(scope.row)">
                <el-option :label="$t('crm_rent_hire.zi_dong_guan_lian')" :value="1"></el-option>
                <el-option :label="$t('crm_rent_hire.shou_dong_guan_lian')" :value="0"></el-option>
              </el-select>
            </template>
            <template slot="action" slot-scope="scope">
              <span></span>
              <el-button v-if="`${scope.row.relationType}` === '0' && funcView.func_bind_location" type="text" size="mini" @click="onBind(scope.row)">{{ funcView.func_bind_location }}</el-button>
              <el-button v-if="funcView.func_unbind" type="text" size="mini" @click="deleteRenter(scope.row)">{{ funcView.func_unbind }}</el-button>
              <!-- <el-button type="text" size="mini" @click="lesseeEquipment(scope.row)" v-if="`${scope.row.relationType}` === '0' && funcView.func_bind">{{ funcView.func_bind }}</el-button> -->
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
    </div>
    <!-- 关联租赁方-->
    <lessee-rent-dialog v-if="dialogVisible" :model="dialogModel" :data="dialogData" @close="dialogVisible = false" @success="getRenterList"></lessee-rent-dialog>
    <!-- 关联设备 -->
    <lessee-equipment-dialog v-if="dialogVisible1" :model="dialogModel1" :data="dialogData1" @close="dialogVisible1 = false" @success="getRenterList"></lessee-equipment-dialog>
    <!-- 关联项目 -->
    <lessee-location-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getRenterList"></lessee-location-dialog>
  </div>
</template>
<script>
import apis from '@/utils/apis';
import lesseeRentDialog from './lessee_rent_dialog';
import lesseeEquipmentDialog from './lessee_equipment_dialog';
import lesseeLocationDialog from './lessee_location_dialog.vue';

export default {
  components: { lesseeRentDialog, lesseeEquipmentDialog, lesseeLocationDialog },
  props: {
    type: {
      type: String,
      default: 'page',
    },
    roleData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableCode: 'rent_hire',
      app: {},
      rentList: [],
      isLoading: false,
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerId: '',
        partnerType: 'CO', // 集团客户
      },
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 设备弹窗
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // 设备弹窗
      dialogVisible2: false,
      dialogModel2: {},
    };
  },

  watch: {
    roleData: function () {
      this.dialogData.roleData = this.roleData;
      this.getRenterList();
    },
  },
  mounted() {
    this.getTableColumn();
    this.getRenterList();
    this.getFuncView('/customer/groupRelation');
    // this.isLoading = true;
  },
  methods: {
    // 获取应用菜单树
    getRenterList: function () {
      this.formSearch.partnerId = this.roleData.partnerId;
      if (this.formSearch.partnerId) {
        this.$getJSON(apis.partnerCustomerPage, this.formSearch).then((res) => {
          if (res.code === 0) {
            this.isLoading = false;
            this.rentList = res.data.list || [];
            this.totalRows = res.data.total;
          }
        });
      } else {
        this.isLoading = false;
        this.rentList = [];
        this.totalRows = null;
      }
    },
    // 关联项目弹窗
    onBind: function (row) {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('crm_rent_hire.guan_lian_xiang_mu');
      this.dialogModel2.type = 'rent';
      this.dialogModel2.data = row;
      this.dialogModel2.largeCustomerId = this.roleData.partnerOrgId;
    },
    // 删除表格列
    deleteRenter: function ({ partnerId }) {
      this.$showConfirm(this.$t('crm_rent_hire.nqdyscdqglm')).then(() => {
        this.$postJSON(`${apis.partnerlargeCustomerCustomerUnlink}/${this.roleData.partnerOrgId}/${partnerId}`).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getRenterList();
          }
        });
      })
        .catch(() => {});
    },
    changeRelation: function (row) {
      const parameter = {
        largeCustomerId: this.roleData.partnerOrgId,
        customerId: row.partnerOrgId,
        relationType: row.relationType,
      };
      this.$postJSON(apis.partnerLargeCustomerCustomerRelationType, parameter).then((res) => {
        if (res.code === 0) {
          this.getRenterList();
        }
      });
    },
    // 关联弹窗
    lessee: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_rent_hire.glzlf');
      this.dialogData = this.roleData;
    },
    lesseeEquipment: function (row) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('crm_rent_hire.guan_lian_she_bei');
      // this.dialogData = this.roleData;
      this.dialogData1.partnerId = row.partnerId;
      this.dialogData1.largeCustomerId = this.roleData.partnerOrgId;
      this.dialogData1.customerId = row.partnerOrgId;
    },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getRenterList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getRenterList();
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRenterList();
    },
  },
};
</script>

<style lang="scss">
.rent-hire-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 0;
  .wrap {
    padding: 20px;
    display: flex;
    flex: 1;
    height: 0;
  }
  .per-aside {
    width: 150px;
    margin-right: 20px;
    ul li {
      line-height: 34px;
      height: 34px;
      text-align: center;
      color: #727272;
      font-size: 12px;
      border-radius: 2px 0px 0px 2px;
      overflow: hidden;
      border: 1px solid #e4e4e4;
      margin-bottom: 8px;
      cursor: pointer;
      &.cur {
        color: #ffffff;
        background: #00a2df;
        border: 1px solid #00a2df;
      }
    }
  }
  .per-wrap {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    .el-checkbox__label {
      color: #262626;
      line-height: 23px;
      font-weight: normal;
      font-size: 12px;
    }
    .checkall {
      display: flex;
      align-items: center;
      padding-right: 15px;
      margin-right: 15px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        bottom: 2px;
        width: 1px;
        background-color: #e4e4e4;
      }
    }
  }
}
</style>
